import { lang } from "../assets/languages/en.language";
import { theme } from "../configs/theme";
import { Question } from "../services/api";
import { QuestionContainer } from "../styles/Container.style";
import { Paragraph, Title } from "../styles/Text";
import { Column } from "../styles/Utils";

interface QuestionsViewProps {
  questions: Question[];
}

export const QuestionsView = ({ questions }: QuestionsViewProps) => {
  return questions.length > 0 ? (
    <Column $gap={1}>
      {questions.map((question) => {
        const langQuestion = lang.updateAboutThemPage.questions.find((e) => e.key == question.key);

        return (
          <QuestionContainer key={question.key}>
            <Title $color={theme.color.primaryDark}>{langQuestion?.title}</Title>
            <Paragraph>{question.answer}</Paragraph>
          </QuestionContainer>
        );
      })}
    </Column>
  ) : (
    <Paragraph>{lang.swiperPage.noQuestionLabel}</Paragraph>
  );
};
